// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__3kZzD","footer":"ModalUpdate_footer__vScyB"};